import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const CasesBox = () => {
	const block = document.querySelectorAll(".cases-box");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		gsap.registerPlugin(ScrollTrigger);
		let mm = gsap.matchMedia();
		let blockOnLeave = false;
		const list = el.querySelector(".cases-box__list");
		const listWrap = el.querySelector(".cases-box__list-wrap");
		const videos = el.querySelectorAll(".cases-box__case-video .inline-video__el");
		if (!listWrap) {
			return;
		}

		const mutedVideos = () => {
			videos.forEach(video => {
				if (video.classList.contains("playing")) {
					video.muted = true;
					video.classList.remove("muted");
					video.closest(".inline-video").querySelector(".inline-video__control").classList.remove("active");
				}
			});
		};

		mm.add("(min-width: 768px)", () => {
			const scrollScene = gsap.to(list, {
				x: () => -list.scrollWidth + list.offsetWidth,
				ease: "none",
				scrollTrigger: {
					trigger: listWrap,
					start: "center 50%",
					end: () => {
						if (list) {
							return `+=${list.scrollWidth - list.offsetWidth}`
						}
					},
					pin: true,
					scrub: true,
					onLeaveBack: () => {
						mutedVideos();
					},
					onLeave: () => {
						mutedVideos();

						if (!blockOnLeave) {
							ScrollTrigger.getAll().forEach((st) => {
								if (st.trigger.className.includes("split-text-title")) {
									st.kill();
								}
							});
							document.dispatchEvent(new Event("split-text-title-refresh"));
							document.dispatchEvent(new Event("inline-video-refresh"));
							blockOnLeave = true;
						}
					}
				}
			});

			videos.forEach(video => {
				const control = video.closest(".inline-video").querySelector(".inline-video__control");

				const pause = () => {
					if (video.classList.contains("playing")) {
						video.pause();
						video.muted = true;
						video.classList.remove("playing");
						video.classList.remove("muted");
						control.classList.remove("active");
					}
				};

				const play = () => {
					video.play();
					video.classList.add("playing");
				};

				gsap.to(video, {
					y: 0,
					duration: 2,
					scrollTrigger: {
						trigger: video,
						containerAnimation: scrollScene,
						start: "left 50%",
						end: "+=100%",
						scrub: true,
						onEnter: () => {
							play();
						},
						onEnterBack: () => {
							play();
						},
						onLeave: () => {
							pause();
						},
						onLeaveBack: () => {
							pause();
						}
					}
				});
			});
		});
	});
};

export default CasesBox;
